<template>
 <div style="margin-top:-10px !important">
      <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
      <template v-else>
    <!-- Header part -->
    <b-row
      class="hidden-sm-down d-print-none px-pad border-bottom justify-content-center"
      style="height: 42px"
    >
      <b-col cols="4" md="4" xl="4" lg="4" sm="4" xs="4" class="text-left px-0">
        <h2 class="custom-page-title mb-2 mt-1">
          {{ list.amc_header_detail.amc_no }}
        </h2>
      </b-col>

      <b-col
        cols="8"
        md="8"
        xl="8"
        lg="8"
        sm="8"
        xs="8"
        class="text-right px-0"
      >
        <b-button
          variant="success"
          size="sm"
          class="mr-2"
          v-if="
            list.amc_header_detail.is_generate != 1 &&
            RoutePermission(false, '', 'invoice', 'invoice', 'create')
          "
          v-b-modal.invoicegenerate
          >Generate Invoice</b-button
        >

        <b-button
          v-if="
            list.amc_header_detail.is_generate == 1 &&
            RoutePermission(false, '', 'invoice', 'invoice', 'index')
          "
          :to="{
            name: 'InvoiceView',
            params: { id: list.amc_header_detail.inv_hdr_id },
            query: {
              page_from: 'amc_contract',
              id: $route.params.id,
              view_no: list.amc_header_detail.amc_no,
            },
          }"
          variant="primary"
          size="sm"
          class="mr-2"
          >View Invoice</b-button
        >
<b-button variant="primary" 
        size="sm"
        class="mr-2" 
      v-if="RoutePermission(true,'AmcContractCreate','','','')"
        :to="{ name: 'AmcContractCreate', query:{page_from:'view',old_id:$route.params.id}}">
        New AMC Contract
        </b-button>

        <!-- Edit icon -->
        <b-button-group variant="light">
          <b-button
            v-if="RoutePermission(false, '', '', 'amccontract', 'update')"
            size="sm"
            :to="{
              name: 'AmcContractUpdate',
              params: { id: $route.params.id },
              query: { page_from: 'view' },
            }"
            variant="light"
          >
            <i class="la la-edit la-lg"></i>
          </b-button>
          <b-button
            variant="light"
            size="sm"
            title="delete"
            v-if="
              list.amc_header_detail.is_generate != 1 &&
              RoutePermission(false, '', '', 'amccontract', 'delete')
            "
            @click="
              handlingapprovingmodal({
                content: 'Are you sure you want to delete this Amc contract ?',
                title: 'Delete Amc Contract - ' + list.amc_header_detail.amc_no,
                module: 'amccontract/deleteamccontract',
                data: JSON.stringify({
                  id: $route.params.id,
                }),
                RoutePlace: 'AmcContract',
                isRoute: 'true',
                type: 'delete',
                 route_history: amccontract_index_history,
              })
            "
          >
            <i class="glyphicon glyphicon-trash"></i>
          </b-button>
          <b-button
            variant="light"
            size="sm"
            title="close"
             :to="amccontract_index_history ? amccontract_index_history : { name: 'AmcContract' }"
          >
            <i class="la la-remove la-lg text-decoration-none"></i>
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <!--  Tab Details -->
    <div class="d-flex" style="margin-left: -20px; margin-right: -20px">
      <div class="view-content-block border-left d-none d-lg-block">
        <div class="py-3">
          <!--  Item Details -->
          <h6
            class="fw-semi-bold theme-text-color px-pad"
            style="padding-bottom: 6px"
          >
            AMC Contract Details
          </h6>
          <div class="border-bottom"></div>
          <div class="px-pad py-2">
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Product</div>
              <div class="cus-view-addr w-50">
                {{ list.amc_header_detail.pdt_name }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Customer</div>
              <div class="cus-view-addr w-50">
                {{ list.amc_header_detail.cus_name }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Customer ID</div>
              <div class="cus-view-addr w-50">
                {{ list.amc_header_detail.cus_legacy_id }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Mobile No.</div>
              <div class="cus-view-addr w-50">
                {{ list.amc_header_detail.cus_ph_no_1 }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Start Date</div>
              <div class="cus-view-addr w-50">
                {{ getDateFormat(list.amc_header_detail.amc_start_date) }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Expiry Date</div>
              <div class="cus-view-addr w-50">
                {{ getDateFormat(list.amc_header_detail.amc_end_date) }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Renewal Date</div>
              <div class="cus-view-addr w-50">
                {{ getDateFormat(list.amc_header_detail.renewal_date) }}
              </div>
            </div>
            <div
              class="d-flex w-100 py-2"
              v-if="
                list.amc_header_detail.ref_no != '' &&
                list.amc_header_detail.ref_no != null
              "
            >
              <div class="cus-view-addr w-50 text-muted">Ref No</div>
              <div class="cus-view-addr w-50">
                {{ list.amc_header_detail.ref_no }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Tags</div>
              <div class="cus-view-addr w-50">{{ list.amc_tags }}</div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Status</div>
              <div class="cus-view-addr w-50">
                {{ list.amc_header_detail.amc_status_name }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Used Qty</div>
              <div class="cus-view-addr w-50">
                {{ this.list.amc_header_detail.total_used_qty }}/{{
                  this.list.amc_header_detail.total_pdt_qty
                }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Last service</div>
              <div class="cus-view-addr w-50">
                {{ getDateFormat(list.amc_service_date) }}
              </div>
            </div>
            <div class="d-flex w-100 py-2">
              <div class="cus-view-addr w-50 text-muted">Next service</div>
              <div class="cus-view-addr w-50">
                {{ getDateFormat(list.amc_header_detail.next_service_date) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="view-tab-block">
        <b-tabs class="customer_view_tab no-flex-grow mt-2 border-tab">
          <b-tab
            title="Overview"
            title-link-class="  d-block d-lg-none"
            class="p-0"
          >
            <div class="py-3">
              <!--  Item Details -->
              <h6
                class="fw-semi-bold theme-text-color px-pad"
                style="padding-bottom: 6px"
              >
                AMC Contract Details
              </h6>
              <div class="border-bottom"></div>
              <div class="px-pad py-2">
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Product</div>
                  <div class="cus-view-addr w-50">
                    {{ list.amc_header_detail.pdt_name }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Customer</div>
                  <div class="cus-view-addr w-50">
                    {{ list.amc_header_detail.cus_name }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Customer ID</div>
                  <div class="cus-view-addr w-50">
                    {{ list.amc_header_detail.cus_legacy_id }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Mobile No.</div>
                  <div class="cus-view-addr w-50">
                    {{ list.amc_header_detail.cus_ph_no_1 }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Start Date</div>
                  <div class="cus-view-addr w-50">
                    {{ getDateFormat(list.amc_header_detail.amc_start_date) }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Expiry Date</div>
                  <div class="cus-view-addr w-50">
                    {{ getDateFormat(list.amc_header_detail.amc_end_date) }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Renewal Date</div>
                  <div class="cus-view-addr w-50">
                    {{ getDateFormat(list.amc_header_detail.renewal_date) }}
                  </div>
                </div>
                <div
                  class="d-flex w-100 py-2"
                  v-if="
                    list.amc_header_detail.ref_no != '' &&
                    list.amc_header_detail.ref_no != null
                  "
                >
                  <div class="cus-view-addr w-50 text-muted">Ref No</div>
                  <div class="cus-view-addr w-50">
                    {{ list.amc_header_detail.ref_no }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Tags</div>
                  <div class="cus-view-addr w-50">{{ list.amc_tags }}</div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Status</div>
                  <div class="cus-view-addr w-50">
                    {{ list.amc_header_detail.amc_status_name }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Used Qty</div>
                  <div class="cus-view-addr w-50">
                    {{ this.list.amc_header_detail.total_used_qty }}/{{
                      this.list.amc_header_detail.total_pdt_qty
                    }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Last service</div>
                  <div class="cus-view-addr w-50">
                    {{ getDateFormat(list.amc_service_date) }}
                  </div>
                </div>
                <div class="d-flex w-100 py-2">
                  <div class="cus-view-addr w-50 text-muted">Next service</div>
                  <div class="cus-view-addr w-50">
                    {{
                      getDateFormat(list.amc_header_detail.next_service_date)
                    }}
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="AMC Contract" class="p-0" active>
            <div role="tablist">
              <div v-for="(item, index) in list.amc_item_detail" :key="index">
                <div
                  no-body
                  style="display: flow-root; padding-right: 15px"
                  class="pl-4 py-3"
                >
                  <div
                    href="#"
                    variant="light"
                    class="d-flex"
                    :style="
                      item.pdt_used_qty == item.pdt_qty
                        ? 'cursor:pointer;text-decoration: line-through;'
                        : 'cursor:pointer'
                    "
                  >
                    <span
                      @click="item.collapse = !item.collapse"
                      v-b-toggle="'amc_item_detail' + index"
                      style="width: 60%"
                      class="text-truncate collapse-icon"
                    >
                      <span
                        class="pb-1 pr-2 fa fa-plus-circle icon-plus d-none"
                      ></span>
                      <span
                        class="pb-1 pr-2 fa fa-minus-circle icon-minus d-none"
                      ></span>
                      {{ item.pdt_name }}
                    </span>
                    <span style="width: 40%" class="text-right">
                      <span class="mr-2">{{
                        " (" + item.pdt_used_qty + "/" + item.pdt_qty + ")"
                      }}</span>
                      <b-button
                        v-if="
                          RoutePermission(
                            false,
                            '',
                            'invoice',
                            'paymentsreceived',
                            'create'
                          ) &&
                          item.pdt_used_qty != item.pdt_qty &&
                          formatDate(list.amc_header_detail.amc_end_date) >=
                            formatDate(new Date())
                        "
                        class="mb-xs record ml-auto"
                        size="xs"
                        :to="{
                          name: 'AmcContractRecordService',
                          params: { id: item.amc_itm_id },
                          query: { amc_contract_id: $route.params.id },
                        }"
                        variant="primary"
                        >Record Service</b-button
                      >
                    </span>
                  </div>

                  <b-collapse :id="'amc_item_detail' + index">
                    <div class="table-responsive amc-table mt-3">
                      <!--  Service Table-->
                      <table class="table table-bordered w-100">
                        <!--  Service Table head-->

                        <thead>
                          <th width="1%"></th>
                          <th width="30%">Service Date</th>
                          <th width="20%">Service Count</th>
                          <th width="50%">Service Description</th>
                          <th width="10%"></th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(service, serviceindex) in list
                              .amc_service_details[item.amc_itm_id]"
                            :key="service.amc_service_id"
                          >
                            <td>{{ serviceindex + 1 }}</td>
                            <td>{{ getDateFormat(service.service_date) }}</td>

                            <td>{{ service.amc_pdt_qty }}</td>
                            <td style="width: 50%; word-break: break-word">
                              {{ service.service_desc }}
                            </td>

                            <td>
                              <i
                                v-if="
                                  RoutePermission(
                                    false,
                                    '',
                                    '',
                                    'amcservice',
                                    'delete'
                                  )
                                "
                                v-b-modal.deleteservice
                                class="glyphicon glyphicon-trash"
                                @click="
                                  (servicedelete.serviceid =
                                    service.amc_service_id),
                                    (servicedelete.serviceindex = serviceindex),
                                    (servicedelete.amc_itm_id =
                                      item.amc_itm_id),
                                    (amcitemdetailindex = index)
                                "
                              ></i>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-collapse>
                </div>
                <hr class="pb-2" :key="index + 10" />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <b-modal
      id="invoicegenerate"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
      @ok.prevent="callinvoicegenertiondetails()"
      :title="'Generate invoice for ' + list.amc_header_detail.amc_no"
      :ok-disabled="submitted"
    >
      <p>Are you sure you want to generate the invoice(s)?</p>
    </b-modal>
    <b-modal
      id="deleteservice"
      size="md"
      ref="deleteservice"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="submit == true ? loaderIcon + 'Yes' : 'Yes'"
      @ok.prevent="removeServiceRow()"
      title="Delete the service"
      :ok-disabled="submit"
    >
      <p>Are you sure you want to delete the service(s)?</p>
    </b-modal>
    <GlobalModal
      :content="content"
      :module="module"
      :title="title"
      :data="globalmodaldata"
      :isRoute="isRoute"
      :RoutePlace="RoutePlace"
      :type="globalmodaltype"
      :route_history="route_history"
    />
      </template>
  </div>
</template>

<script>
import Widget from "@/components/Widget/Widget";
import { mapState } from "vuex";
import RecordNotFound from "@/pages/Error/RecordNotFound";
import { notificationMixin } from "@/mixins/notification";
import { formatDate } from "@/mixins/formatDate";
import store from "@/store/index"; // vuex store fucntion
export default {
  mixins: [notificationMixin, formatDate],
  components: {
    Widget,
    RecordNotFound
  },
  data() {
    return {
      isRoute: "",
      RoutePlace: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      submit: false,
      servicedelete: {
        amcitemdetailindex: "",
        serviceid: "",
        serviceindex: "",
        amc_itm_id: "",
      },

      amcCollapse: false,
      amcCollapse1: false,
      route_history: "",
    };
  },
  methods: {
    // triggerlocationpage() {
    //   this.list = "";
    //   this.$store.dispatch("amccontract/fetchAmcContractView");
    // },
    removeServiceRow() {
      this.submit = true;
      this.$store
        .dispatch(
          "amccontract/deleteamccontractservice",
          JSON.stringify({
            id: this.servicedelete.serviceid,
          })
        )
        .then((response) => {
          this.submit = false;
          //  reduce the qty
            if(response.data.code==200){
          this.list.amc_item_detail[this.amcitemdetailindex].pdt_used_qty =
            parseInt(
              this.list.amc_item_detail[this.amcitemdetailindex].pdt_used_qty
            ) -
            parseInt(
              this.list.amc_service_details[this.servicedelete.amc_itm_id][
                this.servicedelete.serviceindex
              ].amc_pdt_qty
            );

          this.list.amc_header_detail.total_used_qty =
            parseInt(this.list.amc_header_detail.total_used_qty) -
            parseInt(
              this.list.amc_service_details[this.servicedelete.amc_itm_id][
                this.servicedelete.serviceindex
              ].amc_pdt_qty
            );
          var total_used_qty = parseInt(
            this.list.amc_header_detail.total_used_qty
          );
          var total_pdt_qty = parseInt(
            this.list.amc_header_detail.total_pdt_qty
          );

          if (
            this.formatDate(this.list.amc_header_detail.amc_end_date) >=
              this.formatDate(new Date()) &&
            total_used_qty == 0
          ) {
            this.list.amc_header_detail.amc_status_name = "Open";
          } else if (
            this.formatDate(this.list.amc_header_detail.amc_end_date) <
              this.formatDate(new Date()) &&
            total_pdt_qty != total_used_qty
          ) {
            this.list.amc_header_detail.amc_status_name = "Expired";
          } else if (
            this.formatDate(this.list.amc_header_detail.amc_end_date) >=
              this.formatDate(new Date()) &&
            total_used_qty > 0 &&
            total_used_qty < total_pdt_qty
          ) {
            this.list.amc_header_detail.amc_status_name = "Started";
          } else if (total_used_qty == total_pdt_qty) {
            this.list.amc_header_detail.amc_status_name = "Completed";
          }
          if (this.list.amc_header_detail.amc_status_name == "Open") {
            this.list.amc_service_date = "";
          }
         
          //  splice the service details from ui
          this.list.amc_service_details[this.servicedelete.amc_itm_id].splice(
            this.servicedelete.serviceindex,
            1
          );
           }

          //  hide the modal
          this.$refs.deleteservice.hide();
           window.Messenger().post({
        extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
        message:response.data.status,
        type: response.data.type,
        showCloseButton: true
      });

        });
    },
    //  delete whole invoice
    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },

     callinvoicegenertiondetails() {
      this.submitted = true;
        store
        .dispatch("invoice/fetchAmcContractInvoiceList", parseInt(this.$route.params.id)).then((response)=>{
          if(response.data.code==200){
      this.$router.push({
        name: "AmcInvoice",
        params: {
          id: this.list.amc_header_detail.amc_hdr_id,
        },
        query: { type: "invoice" },
      });
          }
          else{
              this.submitted = false;
              window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message:response.data.status,
              type: response.data.type,
              showCloseButton: true
            });
          }
        })
    
    },
  },
   beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch("settings/fetchinvoicesettings", {
         stg_menu: "AMC Contract",
        stg_name: "amc_settings_details"
      }).then(() => {
      
      next();
    });
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      list: state => state.amccontract.Viewlist,
       status_code: (state) => state.amccontract.status_code,
      status_message: (state) => state.amccontract.status_message,
      status_type: (state) => state.amccontract.status_type,
      amccontract_index_history: (state) => state.amccontract.amccontract_index_history,
    })
  }
};
</script>

